import React from 'react'
import Container from './container'
import Grid from './grid'
import Ctas from './ctas'
import Image from './image'
import Link from './link'

export default function FeatureTiles({ content, tiles }) {
  const { heading, description, ctas } = content ?? {}

  return (
    <section className="bg-secondary text-primary standard-spacing">
      <Container>
        <Grid className="items-center">
          <div className="col-span-12 md:col-start-2 md:col-span-10 lg:col-start-1 lg:col-span-5">
            {heading && <h2 className="heading-3xl">{heading}</h2>}
            {description && <p className="mt-4 body-lg">{description}</p>}
            {ctas?.buttons && <div className="mt-8"><Ctas color="white" size="sm" {...ctas} /></div>}
          </div>
          {tiles?.length && (
            <ul className="mt-6 col-span-12 grid grid-cols-2 gap-8 lg:mt-0 lg:col-start-7 lg:col-span-6">
              {tiles.map(({ image, link }, index) => (
                <li className="flex items-center justify-center filter brightness-0 invert" key={index}>
                  {link ? (
                    <Link className="max-w-[120px] md:max-w-[136px]" {...link}>
                      <Image {...image} />
                    </Link>
                  ) : (
                    <Image className="max-w-[120px] md:max-w-[136px]" {...image} />
                  )}
                </li>
              ))}
            </ul>
          )}
        </Grid>
      </Container>
    </section>
  )
}
